
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire02cb"];
var parcelRegister = parcelRequire.register;
parcelRegister("5mJN3", function(module, exports) {

$parcel$export(module.exports, "getDayDate", function () { return $3e8286d302c2b67e$export$eb6582838991800c; });
const $3e8286d302c2b67e$export$eb6582838991800c = ()=>{
    const d = new Date();
    return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, "0")}-${d.getDate().toString().padStart(2, "0")}`;
};

});

parcelRegister("j770S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5cb3f4c67e10739$export$2e2bcd8739ae039; });

var $1dxTK = parcelRequire("1dxTK");

var $fOQV8 = parcelRequire("fOQV8");

var $qtZ0B = parcelRequire("qtZ0B");

var $h5ZF5 = parcelRequire("h5ZF5");
const $b5cb3f4c67e10739$var$CalendarList = ({ isScrollable: isScrollable = false, events: events = [], order: order = "DESC", handleDelete: handleDelete = null })=>{
    const Elem = (props)=>isScrollable ? /*#__PURE__*/ (0, $1dxTK.jsx)((0, $qtZ0B.default), {
            arrowSpace: "var(--space-medium)",
            shadowHeight: "124px",
            ...props
        }) : /*#__PURE__*/ (0, $1dxTK.jsx)("div", {
            ...props
        });
    const orderedEvents = events.map((e)=>({
            ...e,
            computedDate: e.startDate || e.endDate
        })).sort((a, b)=>{
        if (a.computedDate > b.computedDate) return order === "DESC" ? -1 : 1;
        if (a.computedDate < b.computedDate) return order === "DESC" ? 1 : -1;
        return 0;
    });
    return /*#__PURE__*/ (0, $1dxTK.jsx)(Elem, {
        className: isScrollable ? $h5ZF5.isScrollable : $h5ZF5.grid,
        children: orderedEvents.map((e)=>/*#__PURE__*/ (0, $1dxTK.jsx)((0, $fOQV8.default), {
                insideScrollable: isScrollable,
                ...e,
                onDelete: handleDelete ? handleDelete(e.id) : null
            }, e.id))
    });
};
var $b5cb3f4c67e10739$export$2e2bcd8739ae039 = $b5cb3f4c67e10739$var$CalendarList;

});
parcelRegister("fOQV8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86c7bf83b1f2d393$export$2e2bcd8739ae039; });

var $1dxTK = parcelRequire("1dxTK");

var $88yio = parcelRequire("88yio");

var $aX1RZ = parcelRequire("aX1RZ");

var $jIyMJ = parcelRequire("jIyMJ");

var $5mJN3 = parcelRequire("5mJN3");

var $ictqk = parcelRequire("ictqk");

var $8aByp = parcelRequire("8aByp");

var $f37rc = parcelRequire("f37rc");

var $1c9Rl = parcelRequire("1c9Rl");

var $jVFwa = parcelRequire("jVFwa");

var $ciwi0 = parcelRequire("ciwi0");

var $5iD7c = parcelRequire("5iD7c");

var $bHoW4 = parcelRequire("bHoW4");

var $5Ste3 = parcelRequire("5Ste3");
const $86c7bf83b1f2d393$var$getField = (contents, field, language)=>{
    // User language
    for (const content of contents){
        if (content.language === language && content[field]) return content[field];
    }
    // English (default)
    for (const content of contents){
        if (content.language === "en" && content[field]) return content[field];
    }
    // Fallback, any language
    for (const content of contents){
        if (content[field]) return content[field];
    }
    return null;
};
const $86c7bf83b1f2d393$var$colors = {
    CONTEST: "var(--theme-blue)",
    IRL: "var(--theme-purple)",
    SPONSOR: "var(--theme-green)"
};
const $86c7bf83b1f2d393$var$CalendarEvent = ({ id: id, slug: slug, startDate: startDate, endDate: endDate, type: type, contest: contest, website: website = {}, contents: contents = [], t: t, insideScrollable: insideScrollable = false, allowedActions: allowedActions = [], onDelete: onDelete = null })=>{
    const today = (0, $5mJN3.getDayDate)();
    const { currentInterfaceLanguage: currentInterfaceLanguage } = (0, $8aByp.useLanguage)();
    const title = ($86c7bf83b1f2d393$var$getField(contents, "title", currentInterfaceLanguage) || "").replaceAll("/", " / ").replaceAll("/  ", "/ ").replaceAll("  /", " /");
    const description = $86c7bf83b1f2d393$var$getField(contents, "description", currentInterfaceLanguage);
    const announcementLink = $86c7bf83b1f2d393$var$getField(contents, "announcementLink", currentInterfaceLanguage);
    const feedbackLink = $86c7bf83b1f2d393$var$getField(contents, "feedbackLink", currentInterfaceLanguage);
    const contestLink = contest && contest.isResultsPublic ? `/contests/${contest.id}/${contest.slug}` : null;
    const action = contestLink || feedbackLink || announcementLink || null;
    const color = $86c7bf83b1f2d393$var$colors[type] || $86c7bf83b1f2d393$var$colors.CONTEST;
    const date = parseInt(startDate.split("-")[2], 10);
    const month = parseInt(startDate.split("-")[1], 10);
    const year = parseInt(startDate.split("-")[0], 10);
    const comparableDate = (endDate !== "0000-00-00" ? endDate : null) || startDate || today;
    const monthsTranslations = (0, $ictqk.getMonthsTranslations)(t);
    const actions = [
        ...allowedActions.includes("EDIT") ? [
            {
                title: t("Edit"),
                icon: (0, $88yio.faEdit),
                action: `/calendar/${id}/${slug}/edit`
            }
        ] : [],
        ...allowedActions.includes("DELETE") ? [
            {
                title: t("Delete"),
                icon: (0, $88yio.faTrash),
                action: onDelete ? ()=>onDelete(id) : null
            }
        ] : []
    ];
    return /*#__PURE__*/ (0, $1dxTK.jsxs)((0, $jVFwa.default), {
        id: id,
        className: $5Ste3.card,
        disablePadding: true,
        children: [
            /*#__PURE__*/ (0, $1dxTK.jsxs)((0, $f37rc.default), {
                action: action,
                className: `${$5Ste3.event} ${insideScrollable ? $5Ste3.insideScrollable : ""}`,
                children: [
                    /*#__PURE__*/ (0, $1dxTK.jsxs)("div", {
                        className: `${$5Ste3.date} ${comparableDate < today ? $5Ste3.ended : ""}`,
                        style: {
                            background: color
                        },
                        children: [
                            date > 0 && /*#__PURE__*/ (0, $1dxTK.jsx)("div", {
                                className: $5Ste3.dateDate,
                                children: date
                            }),
                            monthsTranslations?.[month] && /*#__PURE__*/ (0, $1dxTK.jsx)("div", {
                                className: $5Ste3.dateMonth,
                                children: monthsTranslations?.[month]?.substring(0, 3)
                            }),
                            year > 0 && /*#__PURE__*/ (0, $1dxTK.jsx)("div", {
                                className: $5Ste3.dateYear,
                                children: year
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1dxTK.jsxs)("div", {
                        className: $5Ste3.content,
                        children: [
                            /*#__PURE__*/ (0, $1dxTK.jsxs)("div", {
                                className: $5Ste3.head,
                                children: [
                                    /*#__PURE__*/ (0, $1dxTK.jsx)((0, $bHoW4.default), {
                                        h: 5,
                                        className: $5Ste3.title,
                                        children: title
                                    }),
                                    website?.code && /*#__PURE__*/ (0, $1dxTK.jsx)((0, $f37rc.default), {
                                        action: website.link,
                                        className: $5Ste3.logoLink,
                                        children: /*#__PURE__*/ (0, $1dxTK.jsx)((0, $1c9Rl.default), {
                                            className: $5Ste3.logo,
                                            id: website?.code,
                                            alt: website?.title
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1dxTK.jsxs)("div", {
                                className: $5Ste3.description,
                                children: [
                                    endDate && type === "CONTEST" && /*#__PURE__*/ (0, $1dxTK.jsxs)("div", {
                                        className: $5Ste3.deadline,
                                        children: [
                                            t("Deadline:"),
                                            " ",
                                            /*#__PURE__*/ (0, $1dxTK.jsx)((0, $5iD7c.default), {
                                                timestamp: endDate,
                                                showHours: false
                                            })
                                        ]
                                    }),
                                    description
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1dxTK.jsx)((0, $ciwi0.default), {
                actions: actions
            })
        ]
    });
};
var $86c7bf83b1f2d393$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aX1RZ))).memo((0, $jIyMJ.withTranslation)()($86c7bf83b1f2d393$var$CalendarEvent));

});
parcelRegister("1c9Rl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31cceb0f6cdeb247$export$2e2bcd8739ae039; });

var $1dxTK = parcelRequire("1dxTK");

var $kkRwB = parcelRequire("kkRwB");

var $9bpr2 = parcelRequire("9bpr2");

var $dEpZK = parcelRequire("dEpZK");

var $ePbN1 = parcelRequire("ePbN1");

var $5mtmL = parcelRequire("5mtmL");

var $6yChL = parcelRequire("6yChL");

var $fvq5x = parcelRequire("fvq5x");

var $80tHe = parcelRequire("80tHe");

var $2olme = parcelRequire("2olme");

var $YH5E2 = parcelRequire("YH5E2");

var $kvzmo = parcelRequire("kvzmo");

var $bMjzJ = parcelRequire("bMjzJ");

var $ddRSn = parcelRequire("ddRSn");

var $go7K5 = parcelRequire("go7K5");

var $9Q2dH = parcelRequire("9Q2dH");

var $gVDKo = parcelRequire("gVDKo");

var $kKyol = parcelRequire("kKyol");

var $1dt3p = parcelRequire("1dt3p");

var $iE5MY = parcelRequire("iE5MY");

var $fXW1b = parcelRequire("fXW1b");

var $dBWD7 = parcelRequire("dBWD7");

var $3jo54 = parcelRequire("3jo54");

var $cVbWE = parcelRequire("cVbWE");

var $eKAYn = parcelRequire("eKAYn");

var $8885m = parcelRequire("8885m");

var $47iPa = parcelRequire("47iPa");

var $3L4TA = parcelRequire("3L4TA");

var $fBELd = parcelRequire("fBELd");

var $lMJQT = parcelRequire("lMJQT");

var $2RKFs = parcelRequire("2RKFs");

var $eEtx7 = parcelRequire("eEtx7");

var $4IROt = parcelRequire("4IROt");

var $1xeJW = parcelRequire("1xeJW");

var $fJ7MJ = parcelRequire("fJ7MJ");

var $4eEJQ = parcelRequire("4eEJQ");

var $jM5vi = parcelRequire("jM5vi");

var $7T9e6 = parcelRequire("7T9e6");

var $eKRg7 = parcelRequire("eKRg7");

var $6Lyjc = parcelRequire("6Lyjc");

var $8s9HL = parcelRequire("8s9HL");

var $gkCCJ = parcelRequire("gkCCJ");

var $lhM2D = parcelRequire("lhM2D");

var $bHBvQ = parcelRequire("bHBvQ");

var $4crzO = parcelRequire("4crzO");

var $cXLei = parcelRequire("cXLei");

var $6tEc8 = parcelRequire("6tEc8");

var $9BYsw = parcelRequire("9BYsw");

var $gyFQR = parcelRequire("gyFQR");

var $3O47H = parcelRequire("3O47H");

var $jziFw = parcelRequire("jziFw");

var $fTSjb = parcelRequire("fTSjb");

var $9ljes = parcelRequire("9ljes");

var $4SrT9 = parcelRequire("4SrT9");

var $8VET6 = parcelRequire("8VET6");

var $3SgPA = parcelRequire("3SgPA");

var $7lWyp = parcelRequire("7lWyp");

var $aZx40 = parcelRequire("aZx40");

var $gYZR1 = parcelRequire("gYZR1");

var $4AFDo = parcelRequire("4AFDo");

var $71XZh = parcelRequire("71XZh");

var $7bHvy = parcelRequire("7bHvy");

var $7uTRg = parcelRequire("7uTRg");

var $7wIK9 = parcelRequire("7wIK9");

var $gjifA = parcelRequire("gjifA");
const $31cceb0f6cdeb247$var$icons = {
    BrickABrack: (0, $kkRwB.chooseBestImage)([
        (0, (/*@__PURE__*/$parcel$interopDefault($dEpZK))),
        (0, (/*@__PURE__*/$parcel$interopDefault($ePbN1))),
        (0, (/*@__PURE__*/$parcel$interopDefault($9bpr2)))
    ]),
    BrickBoard: (0, $kkRwB.chooseBestImage)([
        (0, (/*@__PURE__*/$parcel$interopDefault($6yChL))),
        (0, (/*@__PURE__*/$parcel$interopDefault($fvq5x))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5mtmL)))
    ]),
    BrickCinema: (0, $kkRwB.chooseBestImage)([
        (0, (/*@__PURE__*/$parcel$interopDefault($2olme))),
        (0, (/*@__PURE__*/$parcel$interopDefault($YH5E2))),
        (0, (/*@__PURE__*/$parcel$interopDefault($80tHe)))
    ]),
    BrickfilmDay: (0, $kkRwB.chooseBestImage)([
        (0, (/*@__PURE__*/$parcel$interopDefault($9Q2dH))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gVDKo))),
        (0, (/*@__PURE__*/$parcel$interopDefault($go7K5)))
    ]),
    BrickfilmersGuild: (0, $kkRwB.chooseBestImage)([
        (0, (/*@__PURE__*/$parcel$interopDefault($1dt3p))),
        (0, (/*@__PURE__*/$parcel$interopDefault($iE5MY))),
        (0, (/*@__PURE__*/$parcel$interopDefault($kKyol)))
    ]),
    Brickfilms: (0, $kkRwB.chooseBestImage)([
        (0, (/*@__PURE__*/$parcel$interopDefault($dBWD7))),
        (0, (/*@__PURE__*/$parcel$interopDefault($3jo54))),
        (0, (/*@__PURE__*/$parcel$interopDefault($fXW1b)))
    ]),
    BrickFlicks: (0, $kkRwB.chooseBestImage)([
        (0, (/*@__PURE__*/$parcel$interopDefault($eKAYn))),
        (0, (/*@__PURE__*/$parcel$interopDefault($8885m))),
        (0, (/*@__PURE__*/$parcel$interopDefault($cVbWE)))
    ]),
    BricksInMotion: (0, $kkRwB.chooseBestImage)([
        (0, (/*@__PURE__*/$parcel$interopDefault($2RKFs))),
        (0, (/*@__PURE__*/$parcel$interopDefault($eEtx7))),
        (0, (/*@__PURE__*/$parcel$interopDefault($lMJQT)))
    ]),
    BrickWorldFilmFestival: (0, $kkRwB.chooseBestImage)([
        (0, (/*@__PURE__*/$parcel$interopDefault($jM5vi))),
        (0, (/*@__PURE__*/$parcel$interopDefault($7T9e6))),
        (0, (/*@__PURE__*/$parcel$interopDefault($4eEJQ)))
    ]),
    CineBrick: (0, $kkRwB.chooseBestImage)([
        (0, (/*@__PURE__*/$parcel$interopDefault($6Lyjc))),
        (0, (/*@__PURE__*/$parcel$interopDefault($8s9HL))),
        (0, (/*@__PURE__*/$parcel$interopDefault($eKRg7)))
    ]),
    Klug: (0, $kkRwB.chooseBestImage)([
        (0, (/*@__PURE__*/$parcel$interopDefault($gyFQR))),
        (0, (/*@__PURE__*/$parcel$interopDefault($3O47H))),
        (0, (/*@__PURE__*/$parcel$interopDefault($9BYsw)))
    ]),
    Lego: (0, $kkRwB.chooseBestImage)([
        (0, (/*@__PURE__*/$parcel$interopDefault($fTSjb))),
        (0, (/*@__PURE__*/$parcel$interopDefault($9ljes))),
        (0, (/*@__PURE__*/$parcel$interopDefault($jziFw)))
    ]),
    Wmbf: (0, $kkRwB.chooseBestImage)([
        (0, (/*@__PURE__*/$parcel$interopDefault($7wIK9))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gjifA))),
        (0, (/*@__PURE__*/$parcel$interopDefault($7uTRg)))
    ]),
    BrickVideoStudio: (0, $kkRwB.chooseBestImage)([
        (0, (/*@__PURE__*/$parcel$interopDefault($1xeJW))),
        (0, (/*@__PURE__*/$parcel$interopDefault($fJ7MJ))),
        (0, (/*@__PURE__*/$parcel$interopDefault($4IROt)))
    ]),
    BrickFest: (0, $kkRwB.chooseBestImage)([
        (0, (/*@__PURE__*/$parcel$interopDefault($bMjzJ))),
        (0, (/*@__PURE__*/$parcel$interopDefault($ddRSn))),
        (0, (/*@__PURE__*/$parcel$interopDefault($kvzmo)))
    ]),
    BricksByTheBay: (0, $kkRwB.chooseBestImage)([
        (0, (/*@__PURE__*/$parcel$interopDefault($3L4TA))),
        (0, (/*@__PURE__*/$parcel$interopDefault($fBELd))),
        (0, (/*@__PURE__*/$parcel$interopDefault($47iPa)))
    ]),
    Palikkatakomo: (0, $kkRwB.chooseBestImage)([
        (0, (/*@__PURE__*/$parcel$interopDefault($aZx40))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gYZR1))),
        (0, (/*@__PURE__*/$parcel$interopDefault($7lWyp)))
    ]),
    NWBrickCon: (0, $kkRwB.chooseBestImage)([
        (0, (/*@__PURE__*/$parcel$interopDefault($8VET6))),
        (0, (/*@__PURE__*/$parcel$interopDefault($3SgPA))),
        (0, (/*@__PURE__*/$parcel$interopDefault($4SrT9)))
    ]),
    CineBriqueVQ: (0, $kkRwB.chooseBestImage)([
        (0, (/*@__PURE__*/$parcel$interopDefault($cXLei))),
        (0, (/*@__PURE__*/$parcel$interopDefault($6tEc8))),
        (0, (/*@__PURE__*/$parcel$interopDefault($4crzO)))
    ]),
    CineBriqueVF: (0, $kkRwB.chooseBestImage)([
        (0, (/*@__PURE__*/$parcel$interopDefault($lhM2D))),
        (0, (/*@__PURE__*/$parcel$interopDefault($bHBvQ))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gkCCJ)))
    ]),
    TheBrickFlixFestival: (0, $kkRwB.chooseBestImage)([
        (0, (/*@__PURE__*/$parcel$interopDefault($71XZh))),
        (0, (/*@__PURE__*/$parcel$interopDefault($7bHvy))),
        (0, (/*@__PURE__*/$parcel$interopDefault($4AFDo)))
    ])
};
const $31cceb0f6cdeb247$var$CalendarWebsiteLogo = ({ id: id = null, ...rest })=>{
    if (!$31cceb0f6cdeb247$var$icons[id]) return null;
    return /*#__PURE__*/ (0, $1dxTK.jsx)("img", {
        ...rest,
        src: $31cceb0f6cdeb247$var$icons[id],
        loading: "lazy"
    });
};
var $31cceb0f6cdeb247$export$2e2bcd8739ae039 = $31cceb0f6cdeb247$var$CalendarWebsiteLogo;

});
parcelRegister("9bpr2", function(module, exports) {
module.exports = new URL("BrickABrack.93399f38.avif", import.meta.url).toString();

});

parcelRegister("dEpZK", function(module, exports) {
module.exports = new URL("BrickABrack.af7ad9a5.jpeg", import.meta.url).toString();

});

parcelRegister("ePbN1", function(module, exports) {
module.exports = new URL("BrickABrack.fa6c3813.webp", import.meta.url).toString();

});

parcelRegister("5mtmL", function(module, exports) {
module.exports = new URL("BrickBoard.2aba3766.avif", import.meta.url).toString();

});

parcelRegister("6yChL", function(module, exports) {
module.exports = new URL("BrickBoard.07f48119.jpeg", import.meta.url).toString();

});

parcelRegister("fvq5x", function(module, exports) {
module.exports = new URL("BrickBoard.15f9507e.webp", import.meta.url).toString();

});

parcelRegister("80tHe", function(module, exports) {
module.exports = new URL("BrickCinema.4c27da8b.avif", import.meta.url).toString();

});

parcelRegister("2olme", function(module, exports) {
module.exports = new URL("BrickCinema.ae5d8c36.jpeg", import.meta.url).toString();

});

parcelRegister("YH5E2", function(module, exports) {
module.exports = new URL("BrickCinema.3513aa64.webp", import.meta.url).toString();

});

parcelRegister("kvzmo", function(module, exports) {
module.exports = new URL("BrickFest.f3cba0ca.avif", import.meta.url).toString();

});

parcelRegister("bMjzJ", function(module, exports) {
module.exports = new URL("BrickFest.58de2f5c.jpeg", import.meta.url).toString();

});

parcelRegister("ddRSn", function(module, exports) {
module.exports = new URL("BrickFest.b64030aa.webp", import.meta.url).toString();

});

parcelRegister("go7K5", function(module, exports) {
module.exports = new URL("BrickfilmDay.9bedb139.avif", import.meta.url).toString();

});

parcelRegister("9Q2dH", function(module, exports) {
module.exports = new URL("BrickfilmDay.e6b7af40.jpeg", import.meta.url).toString();

});

parcelRegister("gVDKo", function(module, exports) {
module.exports = new URL("BrickfilmDay.b9927a7c.webp", import.meta.url).toString();

});

parcelRegister("kKyol", function(module, exports) {
module.exports = new URL("BrickfilmersGuild.8b2f74c6.avif", import.meta.url).toString();

});

parcelRegister("1dt3p", function(module, exports) {
module.exports = new URL("BrickfilmersGuild.d568c2fd.jpeg", import.meta.url).toString();

});

parcelRegister("iE5MY", function(module, exports) {
module.exports = new URL("BrickfilmersGuild.a4911b42.webp", import.meta.url).toString();

});

parcelRegister("fXW1b", function(module, exports) {
module.exports = new URL("Brickfilms.7857e968.avif", import.meta.url).toString();

});

parcelRegister("dBWD7", function(module, exports) {
module.exports = new URL("Brickfilms.531c8ae9.jpeg", import.meta.url).toString();

});

parcelRegister("3jo54", function(module, exports) {
module.exports = new URL("Brickfilms.22167702.webp", import.meta.url).toString();

});

parcelRegister("cVbWE", function(module, exports) {
module.exports = new URL("BrickFlicks.e91d9646.avif", import.meta.url).toString();

});

parcelRegister("eKAYn", function(module, exports) {
module.exports = new URL("BrickFlicks.a262cd02.jpeg", import.meta.url).toString();

});

parcelRegister("8885m", function(module, exports) {
module.exports = new URL("BrickFlicks.0e66b069.webp", import.meta.url).toString();

});

parcelRegister("47iPa", function(module, exports) {
module.exports = new URL("BricksByTheBay.239680cf.avif", import.meta.url).toString();

});

parcelRegister("3L4TA", function(module, exports) {
module.exports = new URL("BricksByTheBay.a1028cbc.jpeg", import.meta.url).toString();

});

parcelRegister("fBELd", function(module, exports) {
module.exports = new URL("BricksByTheBay.1714599a.webp", import.meta.url).toString();

});

parcelRegister("lMJQT", function(module, exports) {
module.exports = new URL("BricksInMotion.2bdd2cb2.avif", import.meta.url).toString();

});

parcelRegister("2RKFs", function(module, exports) {
module.exports = new URL("BricksInMotion.7da6989b.jpeg", import.meta.url).toString();

});

parcelRegister("eEtx7", function(module, exports) {
module.exports = new URL("BricksInMotion.e71e100b.webp", import.meta.url).toString();

});

parcelRegister("4IROt", function(module, exports) {
module.exports = new URL("BrickVideoStudio.56cd45ed.avif", import.meta.url).toString();

});

parcelRegister("1xeJW", function(module, exports) {
module.exports = new URL("BrickVideoStudio.66129c08.jpeg", import.meta.url).toString();

});

parcelRegister("fJ7MJ", function(module, exports) {
module.exports = new URL("BrickVideoStudio.fa00b2ff.webp", import.meta.url).toString();

});

parcelRegister("4eEJQ", function(module, exports) {
module.exports = new URL("BrickWorldFilmFestival.7b5e2f0c.avif", import.meta.url).toString();

});

parcelRegister("jM5vi", function(module, exports) {
module.exports = new URL("BrickWorldFilmFestival.858e5420.jpeg", import.meta.url).toString();

});

parcelRegister("7T9e6", function(module, exports) {
module.exports = new URL("BrickWorldFilmFestival.fb3abce2.webp", import.meta.url).toString();

});

parcelRegister("eKRg7", function(module, exports) {
module.exports = new URL("CineBrick.219ac439.avif", import.meta.url).toString();

});

parcelRegister("6Lyjc", function(module, exports) {
module.exports = new URL("CineBrick.ad520543.jpeg", import.meta.url).toString();

});

parcelRegister("8s9HL", function(module, exports) {
module.exports = new URL("CineBrick.d1d5a746.webp", import.meta.url).toString();

});

parcelRegister("gkCCJ", function(module, exports) {
module.exports = new URL("CineBriqueVF.2d541355.avif", import.meta.url).toString();

});

parcelRegister("lhM2D", function(module, exports) {
module.exports = new URL("CineBriqueVF.77fe7595.jpeg", import.meta.url).toString();

});

parcelRegister("bHBvQ", function(module, exports) {
module.exports = new URL("CineBriqueVF.03592e24.webp", import.meta.url).toString();

});

parcelRegister("4crzO", function(module, exports) {
module.exports = new URL("CineBriqueVQ.0d68f6c0.avif", import.meta.url).toString();

});

parcelRegister("cXLei", function(module, exports) {
module.exports = new URL("CineBriqueVQ.97bce5b1.jpeg", import.meta.url).toString();

});

parcelRegister("6tEc8", function(module, exports) {
module.exports = new URL("CineBriqueVQ.9e063966.webp", import.meta.url).toString();

});

parcelRegister("9BYsw", function(module, exports) {
module.exports = new URL("Klug.ca5e2ff0.avif", import.meta.url).toString();

});

parcelRegister("gyFQR", function(module, exports) {
module.exports = new URL("Klug.5976c746.jpeg", import.meta.url).toString();

});

parcelRegister("3O47H", function(module, exports) {
module.exports = new URL("Klug.f5d1488e.webp", import.meta.url).toString();

});

parcelRegister("jziFw", function(module, exports) {
module.exports = new URL("Lego.09745725.avif", import.meta.url).toString();

});

parcelRegister("fTSjb", function(module, exports) {
module.exports = new URL("Lego.71d26db9.jpeg", import.meta.url).toString();

});

parcelRegister("9ljes", function(module, exports) {
module.exports = new URL("Lego.541ea2bd.webp", import.meta.url).toString();

});

parcelRegister("4SrT9", function(module, exports) {
module.exports = new URL("NWBrickCon.2304f89c.avif", import.meta.url).toString();

});

parcelRegister("8VET6", function(module, exports) {
module.exports = new URL("NWBrickCon.69588f3e.jpeg", import.meta.url).toString();

});

parcelRegister("3SgPA", function(module, exports) {
module.exports = new URL("NWBrickCon.17492363.webp", import.meta.url).toString();

});

parcelRegister("7lWyp", function(module, exports) {
module.exports = new URL("Palikkatakomo.eafa76ec.avif", import.meta.url).toString();

});

parcelRegister("aZx40", function(module, exports) {
module.exports = new URL("Palikkatakomo.32b029dc.jpeg", import.meta.url).toString();

});

parcelRegister("gYZR1", function(module, exports) {
module.exports = new URL("Palikkatakomo.f7a50058.webp", import.meta.url).toString();

});

parcelRegister("4AFDo", function(module, exports) {
module.exports = new URL("TheBrickFlixFestival.0e1f478b.avif", import.meta.url).toString();

});

parcelRegister("71XZh", function(module, exports) {
module.exports = new URL("TheBrickFlixFestival.cfeee8cd.jpeg", import.meta.url).toString();

});

parcelRegister("7bHvy", function(module, exports) {
module.exports = new URL("TheBrickFlixFestival.fa1a92a1.webp", import.meta.url).toString();

});

parcelRegister("7uTRg", function(module, exports) {
module.exports = new URL("Wmbf.7914dfe6.avif", import.meta.url).toString();

});

parcelRegister("7wIK9", function(module, exports) {
module.exports = new URL("Wmbf.9695fca6.jpeg", import.meta.url).toString();

});

parcelRegister("gjifA", function(module, exports) {
module.exports = new URL("Wmbf.a64c4fd7.webp", import.meta.url).toString();

});


parcelRegister("ciwi0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d7a6aebf33dcad5$export$2e2bcd8739ae039; });

var $1dxTK = parcelRequire("1dxTK");

var $dOgIH = parcelRequire("dOgIH");

var $f37rc = parcelRequire("f37rc");

var $4qTg9 = parcelRequire("4qTg9");
// [{title, action, icon}]
const $2d7a6aebf33dcad5$var$CardActions = ({ actions: actions = [] })=>actions.length === 0 ? null : /*#__PURE__*/ (0, $1dxTK.jsx)("div", {
        className: $4qTg9.shadow,
        children: /*#__PURE__*/ (0, $1dxTK.jsx)("div", {
            className: $4qTg9.container,
            children: actions.map((e)=>/*#__PURE__*/ (0, $1dxTK.jsxs)((0, $f37rc.default), {
                    className: $4qTg9.action,
                    action: e.action,
                    children: [
                        e.icon && /*#__PURE__*/ (0, $1dxTK.jsx)((0, $dOgIH.FontAwesomeIcon), {
                            icon: e.icon
                        }),
                        e.title
                    ]
                }, e.title))
        })
    });
var $2d7a6aebf33dcad5$export$2e2bcd8739ae039 = $2d7a6aebf33dcad5$var$CardActions;

});
parcelRegister("4qTg9", function(module, exports) {

$parcel$export(module.exports, "action", function () { return $33a47486f26d8846$export$31eb53bd5b582a97; }, function (v) { return $33a47486f26d8846$export$31eb53bd5b582a97 = v; });
$parcel$export(module.exports, "container", function () { return $33a47486f26d8846$export$34e0f9847d4c02dd; }, function (v) { return $33a47486f26d8846$export$34e0f9847d4c02dd = v; });
$parcel$export(module.exports, "shadow", function () { return $33a47486f26d8846$export$b8972b998723d602; }, function (v) { return $33a47486f26d8846$export$b8972b998723d602 = v; });
var $33a47486f26d8846$export$31eb53bd5b582a97;
var $33a47486f26d8846$export$34e0f9847d4c02dd;
var $33a47486f26d8846$export$b8972b998723d602;
$33a47486f26d8846$export$31eb53bd5b582a97 = `prxg_q_action`;
$33a47486f26d8846$export$34e0f9847d4c02dd = `prxg_q_container`;
$33a47486f26d8846$export$b8972b998723d602 = `prxg_q_shadow`;

});


parcelRegister("5Ste3", function(module, exports) {

$parcel$export(module.exports, "card", function () { return $4478aa7e763ade8d$export$aa3e815946b80764; }, function (v) { return $4478aa7e763ade8d$export$aa3e815946b80764 = v; });
$parcel$export(module.exports, "content", function () { return $4478aa7e763ade8d$export$a7db06668cad9adb; }, function (v) { return $4478aa7e763ade8d$export$a7db06668cad9adb = v; });
$parcel$export(module.exports, "date", function () { return $4478aa7e763ade8d$export$324d90190a8b822a; }, function (v) { return $4478aa7e763ade8d$export$324d90190a8b822a = v; });
$parcel$export(module.exports, "dateDate", function () { return $4478aa7e763ade8d$export$74830f523305ea9f; }, function (v) { return $4478aa7e763ade8d$export$74830f523305ea9f = v; });
$parcel$export(module.exports, "dateMonth", function () { return $4478aa7e763ade8d$export$c3155d2675ee2256; }, function (v) { return $4478aa7e763ade8d$export$c3155d2675ee2256 = v; });
$parcel$export(module.exports, "dateYear", function () { return $4478aa7e763ade8d$export$e7253ed0fc7be0c3; }, function (v) { return $4478aa7e763ade8d$export$e7253ed0fc7be0c3 = v; });
$parcel$export(module.exports, "deadline", function () { return $4478aa7e763ade8d$export$6a57f01f097f1a72; }, function (v) { return $4478aa7e763ade8d$export$6a57f01f097f1a72 = v; });
$parcel$export(module.exports, "description", function () { return $4478aa7e763ade8d$export$6d59db4903f20f7d; }, function (v) { return $4478aa7e763ade8d$export$6d59db4903f20f7d = v; });
$parcel$export(module.exports, "ended", function () { return $4478aa7e763ade8d$export$999b7b72c79021f2; }, function (v) { return $4478aa7e763ade8d$export$999b7b72c79021f2 = v; });
$parcel$export(module.exports, "event", function () { return $4478aa7e763ade8d$export$6cd530ed55e06764; }, function (v) { return $4478aa7e763ade8d$export$6cd530ed55e06764 = v; });
$parcel$export(module.exports, "head", function () { return $4478aa7e763ade8d$export$5fd5031fecdacec3; }, function (v) { return $4478aa7e763ade8d$export$5fd5031fecdacec3 = v; });
$parcel$export(module.exports, "insideScrollable", function () { return $4478aa7e763ade8d$export$ed20dcc501311c15; }, function (v) { return $4478aa7e763ade8d$export$ed20dcc501311c15 = v; });
$parcel$export(module.exports, "logo", function () { return $4478aa7e763ade8d$export$db3c28d99448dcff; }, function (v) { return $4478aa7e763ade8d$export$db3c28d99448dcff = v; });
$parcel$export(module.exports, "logoLink", function () { return $4478aa7e763ade8d$export$ca5ab360c5bee0b1; }, function (v) { return $4478aa7e763ade8d$export$ca5ab360c5bee0b1 = v; });
$parcel$export(module.exports, "title", function () { return $4478aa7e763ade8d$export$fb184b623420d9be; }, function (v) { return $4478aa7e763ade8d$export$fb184b623420d9be = v; });
var $4478aa7e763ade8d$export$aa3e815946b80764;
var $4478aa7e763ade8d$export$a7db06668cad9adb;
var $4478aa7e763ade8d$export$324d90190a8b822a;
var $4478aa7e763ade8d$export$74830f523305ea9f;
var $4478aa7e763ade8d$export$c3155d2675ee2256;
var $4478aa7e763ade8d$export$e7253ed0fc7be0c3;
var $4478aa7e763ade8d$export$6a57f01f097f1a72;
var $4478aa7e763ade8d$export$6d59db4903f20f7d;
var $4478aa7e763ade8d$export$999b7b72c79021f2;
var $4478aa7e763ade8d$export$6cd530ed55e06764;
var $4478aa7e763ade8d$export$5fd5031fecdacec3;
var $4478aa7e763ade8d$export$ed20dcc501311c15;
var $4478aa7e763ade8d$export$db3c28d99448dcff;
var $4478aa7e763ade8d$export$ca5ab360c5bee0b1;
var $4478aa7e763ade8d$export$fb184b623420d9be;
$4478aa7e763ade8d$export$aa3e815946b80764 = `hHWYUq_card`;
$4478aa7e763ade8d$export$a7db06668cad9adb = `hHWYUq_content`;
$4478aa7e763ade8d$export$324d90190a8b822a = `hHWYUq_date`;
$4478aa7e763ade8d$export$74830f523305ea9f = `hHWYUq_dateDate`;
$4478aa7e763ade8d$export$c3155d2675ee2256 = `hHWYUq_dateMonth`;
$4478aa7e763ade8d$export$e7253ed0fc7be0c3 = `hHWYUq_dateYear`;
$4478aa7e763ade8d$export$6a57f01f097f1a72 = `hHWYUq_deadline`;
$4478aa7e763ade8d$export$6d59db4903f20f7d = `hHWYUq_description`;
$4478aa7e763ade8d$export$999b7b72c79021f2 = `hHWYUq_ended`;
$4478aa7e763ade8d$export$6cd530ed55e06764 = `hHWYUq_event`;
$4478aa7e763ade8d$export$5fd5031fecdacec3 = `hHWYUq_head`;
$4478aa7e763ade8d$export$ed20dcc501311c15 = `hHWYUq_insideScrollable`;
$4478aa7e763ade8d$export$db3c28d99448dcff = `hHWYUq_logo`;
$4478aa7e763ade8d$export$ca5ab360c5bee0b1 = `hHWYUq_logoLink`;
$4478aa7e763ade8d$export$fb184b623420d9be = `hHWYUq_title`;

});


parcelRegister("h5ZF5", function(module, exports) {

$parcel$export(module.exports, "grid", function () { return $c722bc04926f413a$export$85fc379452d91af0; }, function (v) { return $c722bc04926f413a$export$85fc379452d91af0 = v; });
$parcel$export(module.exports, "isScrollable", function () { return $c722bc04926f413a$export$2bb74740c4e19def; }, function (v) { return $c722bc04926f413a$export$2bb74740c4e19def = v; });
var $c722bc04926f413a$export$85fc379452d91af0;
var $c722bc04926f413a$export$2bb74740c4e19def;
$c722bc04926f413a$export$85fc379452d91af0 = `JZ7ura_grid`;
$c722bc04926f413a$export$2bb74740c4e19def = `JZ7ura_isScrollable`;

});



//# sourceMappingURL=Homepage.969dcb5f.js.map
